import { render, staticRenderFns } from "./AiChatWidget.vue?vue&type=template&id=6e28cc95&scoped=true"
import script from "./AiChatWidget.vue?vue&type=script&lang=js"
export * from "./AiChatWidget.vue?vue&type=script&lang=js"
import style0 from "./AiChatWidget.vue?vue&type=style&index=0&id=6e28cc95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28cc95",
  null
  
)

export default component.exports